window.$ = window.jQuery = require('jquery');

(function () {
    var $ctr = $(".mensajes");
    if ($ctr.length > 0) {
        var total = $ctr.find(".mensaje").length;
        var apuntado = 0;
        var tempo = null;
        $ctr.find(".mensaje").eq(apuntado).addClass("visible");

        function arrancar() {
            if (total > 1) {
                tempo = window.setTimeout(avanzar, 10000);
            }
        }

        function avanzar() {
            var ultimo = total - 1;

            var posterior = apuntado + 1;
            if (posterior > ultimo) {
                posterior = 0;
            }
            seleccionar(posterior);
        }

        function seleccionar(proximo) {
            var $apuntado = $ctr.find(".mensaje").eq(apuntado);
            var $proximo = $ctr.find(".mensaje").eq(proximo);

            $apuntado.removeClass("visible");
            $proximo.addClass("visible");

            apuntado = proximo;
            arrancar();
        }

        arrancar();
    }
})();